import Model from "./Model";

export default class Turno extends Model {
  constructor(franquia) {
    super();
    Object.assign(this, franquia);
  }
}
